export let ADDRESS_TARGETS = /*#__PURE__*/function (ADDRESS_TARGETS) {
  ADDRESS_TARGETS["COUNTRY"] = "country";
  ADDRESS_TARGETS["SUBDIVISION"] = "subdivision";
  ADDRESS_TARGETS["CITY"] = "city";
  ADDRESS_TARGETS["ADDRESS_LINE"] = "addressLine";
  ADDRESS_TARGETS["ADDRESS_LINE_2"] = "addressLine2";
  ADDRESS_TARGETS["POSTAL_CODE"] = "postalCode";
  ADDRESS_TARGETS["STREET_NAME"] = "streetName";
  ADDRESS_TARGETS["STREET_NUMBER"] = "streetNumber";
  ADDRESS_TARGETS["APARTMENT"] = "apartment";
  return ADDRESS_TARGETS;
}({});
export function fromAtlasAddress(address, isMultilineAddressField) {
  const {
    country,
    subdivision,
    city,
    addressLine,
    streetAddress,
    addressLine2,
    postalCode
  } = address;
  const partial = {};
  if (isMultilineAddressField) {
    if (country) {
      partial.country = country;
    }
    if (subdivision) {
      partial.subdivision = subdivision;
    }
    if (city) {
      partial.city = city;
    }
    if (addressLine) {
      partial.addressLine = addressLine;
    } else if (streetAddress != null && streetAddress.formattedAddressLine) {
      partial.addressLine = streetAddress == null ? void 0 : streetAddress.formattedAddressLine;
    }
    if (addressLine2) {
      partial.addressLine = addressLine2;
    }
    if (postalCode) {
      partial.postalCode = postalCode;
    }
    if (streetAddress != null && streetAddress.apt) {
      partial.apartment = streetAddress == null ? void 0 : streetAddress.apt;
    }
    if (streetAddress != null && streetAddress.name) {
      partial.streetName = streetAddress == null ? void 0 : streetAddress.name;
    }
    if (streetAddress != null && streetAddress.number) {
      partial.streetNumber = streetAddress.number;
    }
  } else {
    if (country) {
      partial.country = country;
    }
    if (subdivision) {
      partial.subdivision = subdivision;
    }
    if (city) {
      partial.city = city;
    }
    if (addressLine) {
      partial.address_line = addressLine;
    } else if (streetAddress != null && streetAddress.formattedAddressLine) {
      partial.address_line = streetAddress == null ? void 0 : streetAddress.formattedAddressLine;
    }
    if (addressLine2) {
      partial.address_line = addressLine2;
    }
    if (postalCode) {
      partial.postal_code = postalCode;
    }
    if (streetAddress != null && streetAddress.apt) {
      partial.apartment = streetAddress == null ? void 0 : streetAddress.apt;
    }
    if (streetAddress != null && streetAddress.name) {
      partial.street_name = streetAddress == null ? void 0 : streetAddress.name;
    }
    if (streetAddress != null && streetAddress.number) {
      partial.street_number = streetAddress.number;
    }
  }
  return partial;
}
//# sourceMappingURL=address.js.map